'use client'
import React from 'react'
import { isMobileDevice } from 'helpers/utilities'
import { withUploadResumeProvider } from './context'

import UploadResumeMobile from './index.mobile'
import UploadResumePc from './index.pc'

export const UploadResumeMain = (props: { lang: string }) => {
  const isMobile = isMobileDevice()

  if (isMobile) {
    return <UploadResumeMobile {...props} />
  }

  return <UploadResumePc {...props} />
}

export default withUploadResumeProvider(UploadResumeMain)
